<template>
  <v-icon v-bind="$attrs" color="primary" @click="goToLink" :class="margin">{{ mdiBeehiveOutline }}</v-icon>
</template>

<script>
  import { mdiBeehiveOutline } from '@mdi/js';

  export default {
    props: {
      link: String,
      margin: {
        type: String,
        default: 'ml-1 mb-1'
      }
    },

    data() {
      return {
        mdiBeehiveOutline,
      }  
    },

    methods: {
      goToLink() {
        window.open(this.link);
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>